import format from '../../common/utilities/format.js';

function isComparebleHouse(house){
    return house.price > 0 && house.area > 100;
}

function getComparebleAreaPriceList (list){
    if (!list || !list.length) {
        return list;
    }
    return list.reduce(function(prev, next){
        if(isComparebleHouse(next)){
            prev.push(next.pricePerArea);
        }
        return prev;
    }, []);
}

export default {
    getEstPriceForBuildingOnLand(current, list){
        var areaPriceAvg = 0;
        var areaAvg = 0;
        var min = null;
        var max = null;
        var count = 0;
        var priceList = [];
        for(var i = 0; i < list.length; i++){
            if(isComparebleHouse(list[i])){
                areaPriceAvg += list[i].pricePerArea;
                areaAvg += list[i].area;
                priceList.push(list[i].price);
                count++;
            }
        }
        areaPriceAvg = (areaPriceAvg / count).toFixed(0) * 1;
        areaAvg = (areaAvg / count).toFixed(0) * 1;
        // if(priceList && priceList.length){
        //     min = Math.min.apply(null, priceList);
        //     max = Math.max.apply(null, priceList);
        // }
        var estPrice = areaPriceAvg * areaAvg;
        min = estPrice * 0.9;
        max = estPrice * 1.1;
        let estPriceRange = '';
        if (min && max) {
            min = format.friendlyPrice(min);
            max = format.friendlyPrice(max);
            estPriceRange = '$' + min + ' - ' + '$' + max;
        }
        return {
            estPrice: Math.round(estPrice),
            min: Math.round(min),
            max: Math.round(max),
            areaPriceAvg: Math.round(areaPriceAvg),
            areaAvg: Math.round(areaAvg),
            estPriceRange: estPriceRange,
        };
    },
    getEstPriceForProperty(current, _list){
        var area = current.area;
        var list = _list || [];
        if(!current.isLand && !current.isPrOnly && current.pricePerArea){
            list.push(current);
        }
        var areaPriceList = getComparebleAreaPriceList(list);
        var areaPriceAvg = null;
        var estPrice = null;
        var min = null;
        var max = null;
        var percentage = null;
        var isAbove = null;
        if(areaPriceList && areaPriceList.length){
            areaPriceAvg = (areaPriceList.reduce(function(prev, next){
                return prev + next;
            }, 0) / areaPriceList.length);
            if(area){
                estPrice = areaPriceAvg * area;
            }
            min = areaPriceAvg * 0.9;      //Math.min.apply(null, areaPriceList);
            max = areaPriceAvg * 1.1;      //Math.max.apply(null, areaPriceList);
        }

        if (current.price && estPrice) {
            percentage = (estPrice / current.price - 1) * 100;
            isAbove = percentage >= 0;
        }
        let estPriceRange = '';
        if (min && max) {
            min = Math.round(min);
            max = Math.round(max);
            if (area) {
                estPriceRange = '$' + format.friendlyPrice(min * area) + ' - ' + '$' +  format.friendlyPrice(max * area);
            } else {
                estPriceRange = '$' + format.formatNumberByComma(min) + '/Sqft - ' + '$' + format.formatNumberByComma(max) + '/Sqft';
            }
        }
        return {
            estPrice: Math.round(estPrice),
            min: Math.round(min),
            max: Math.round(max),
            areaPriceAvg: Math.round(areaPriceAvg),
            area: Math.round(area),
            percentage: percentage !== null ? Math.abs(percentage.toFixed(2)) : null,
            isAbove: isAbove,
            estPriceRange: estPriceRange,
        };
    }
};
